<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process-custom"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import LocationServices from '@/services/api/location.api'
import ROLE from '@/utils/role'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@//modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Acomodos Razonables',
      routes: ["Informes", "Acomodos Razonables"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          centers: [],
          municipalities: [],
          schools: [],
          users: [],
        },
        filters: {
          academicYear: null,
          center: null,
          centerDisabled: true,
          centerMandatory: false,
          municipality: null,
          municipalityDisabled: true,
          school: null,
          schoolDisabled: true,
          user: null,
          userDisabled: true,
          sie: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        class: "col-md-3",
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged: this.onChangedAcademicYears,
      },
      {
        name: 'center',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'CSEE',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un CSEE.",
        validations: this.model.search.filters.centerMandatory ? "required" : "",
        class: "col-md-3",
        options: this.model.search.collections.centers,
        value: this.model.search.filters.center,
        onChanged: this.onChangedCenter,
        disabled: this.model.search.filters.centerDisabled,
      },
      {
        name: 'municipality',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Municipio',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.municipalities,
        value: this.model.search.filters.municipality,
        onChanged: this.onChangedMunicipality,
        disabled: this.model.search.filters.municipalityDisabled,
      },
      {
        name: 'school',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Escuela',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.schools,
        value: this.model.search.filters.school,
        onChanged: this.onChangedSchool,
        disabled: this.model.search.filters.schoolDisabled,
      },
      {
        name: 'user',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Maestro/Director',
        placeholder: 'Seleccionar',
        class: "col-md-3",
        options: this.model.search.collections.users,
        value: this.model.search.filters.user,
        disabled: this.model.search.filters.userDisabled,
      },
      {
        name: 'sie',
        component: 'CustomInput',
        type: 'text',
        label: 'SIE',
        placeholder: 'Escriba número de SIE',
        icon: 'fa fa-search orange-icon',
        class: "col-md-3",
        leftIcon: true,
        value: this.model.search.filters.sie,
        disabled: this.model.search.filters.sieDisabled,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getExistingPeisAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);
    },
    async onChangedAcademicYears() {
      this.clearCenters();
      this.clearMunicipalities();
      this.clearSchools();
      this.clearUsers();

      if (!this.model.search.filters.academicYear) {
        this.disabledCenter(true);
        this.disabledMunicipality(true);
        this.disabledSchool(true);
        this.disabledUser(true);
        this.model.search.filters.centerMandatory = false;
        return false;
      }

      await this.getCenters();

      this.disabledCenter(false);
      this.model.search.filters.centerMandatory = true;
    },
    async onChangedCenter() {
      this.clearMunicipalities();
      this.clearSchools();
      this.clearUsers();

      if (!this.model.search.filters.center) {
        this.disabledMunicipality(true);
        this.disabledSchool(true);
        this.disabledUser(true);
        return false;
      }

      await this.getMunicipalities();
      this.disabledMunicipality(false);

      await this.getSchools();
      this.disabledSchool(false);

      await this.getUsers();
      this.disabledUser(false);
    },
    async onChangedMunicipality() {
      this.clearSchools();
      this.clearUsers();

      await this.getSchools();
    },
    async onChangedSchool() {
      this.clearUsers();
      
      await this.getUsers();
    },
    async getCenters() {
      await LocationServices.getCenters({
        academicYearId: this.model.search.filters.academicYear.id,
      })
      .then(res => this.model.search.collections.centers = res.data);
    },
    async getMunicipalities() {
      await LocationServices.getMunicipalities({
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
      })
      .then(res => this.model.search.collections.municipalities = res.data);
    },
    async getSchools() {
      await LocationServices.getSchools({
        academicYearId: this.model.search.filters.academicYear.id,
        municipalityId: this.model.search.filters.municipality?.id,
      })
      .then(res => this.model.search.collections.schools = res.data);
    },
    async getUsers() {
      
      const params = {
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center.id,
        municipalityId: this.model.search.filters.municipality?.id,
        schoolId: this.model.search.filters.school?.id,
        roleName: `${ROLE.Maestro}, ${ROLE.Director}`,
      };

     await LocationServices.getUsersSchool(params)
       .then(res => this.model.search.collections.users = res.data);
    },
    disabledCenter(disabled) {
      this.model.search.filters.centerDisabled = disabled;
    },
    disabledMunicipality(disabled) {
      this.model.search.filters.municipalityDisabled = disabled;
    },
    disabledSchool(disabled) {
      this.model.search.filters.schoolDisabled = disabled;
    },
     disabledUser(disabled) {
      this.model.search.filters.userDisabled = disabled;
    },
    clearCenters() {
      this.model.search.filters.center = null;
    },
    clearMunicipalities() {
      this.model.search.filters.municipality = null;
    },
    clearSchools() {
      this.model.search.filters.school = null;
    },
    clearUsers() {
      this.model.search.filters.user = null;
    },
    async onHandlerSearch() {
     const isValid = await this.$refs.filterRef.$refs.formValidator.validate();

      if (isValid) {
        this.process();
      }
    },
    async process() {
      await ReportServices.getReport('peiServiceArrangement', {
        academicYearId: this.model.search.filters.academicYear.id,
        centerId: this.model.search.filters.center?.id,
        municipalityId: this.model.search.filters.municipality?.id,
        schoolId: this.model.search.filters.school?.id,
        studentSIE: this.model.search.filters.sie,
        teacherId: this.model.search.filters.user?.id,
      })
      .then(res => DocumentServices.Download(res.data));
    },
  },
}
</script>

<style scope>
.btn-process-custom {
	position: absolute !important;
  bottom: 17px !important;
  right: 15px !important;
}
</style>

